import React, { useMemo } from 'react'

import NameStep from '../../Steps/NameStep'
import FileUploadStep from '../../Steps/FileUploadStep'
import StepForm from '../../../../../../../features/components/Forms/StepForm'

import { useCreateGamAd } from '../../hooks/useCreateGamAd'

import { AD_TYPE_VIDEO, VIDEO_UPLOAD_TYPE } from '../../fields'

const UploadVideoCreativeRoute = ({ FormRouteSelector, isInternalAdCreation, ...formProps }) => {
  const { purifiedFormik } = useCreateGamAd({
    isInternalAdCreation,
    formatOption: VIDEO_UPLOAD_TYPE
  })

  const steps = useMemo(
    () => [
      {
        component: FormRouteSelector,
        show: true
      },
      {
        component: <NameStep />,
        show: true
      },
      {
        component: <FileUploadStep adType={AD_TYPE_VIDEO} />,
        show: true
      }
    ],
    [FormRouteSelector]
  )

  return <StepForm steps={steps} formik={purifiedFormik} {...formProps} />
}

export default UploadVideoCreativeRoute
